import instance, { bigNumberTransformResponse } from '../index';
import { COMEINURL } from '@/jmHttp/host';
import { summary } from '../interface';

const defaultConfig = {
  bodyType: 'form'
};

// 纪要获取跳转信息的接口
export const getSummaryInfo = async (data) => {
  return instance.post(summary.getSummaryInfo, data);
};
// 纪要页面-筛选项
export const getNewFilterConfigList = async (data, config = {}) => {
  return await instance.post(summary.getNewFilterConfigList, data, config);
};
// 纪要页面-查询列表/我的收藏-纪要
export const querySummaryPage = async (data, config = {}) => {
  return await instance.post(summary.querySummaryPage, data, config);
};
//三方独立纪要列表接口
export const querySummaryThirdPage = async (data, config = {}) => {
  return await instance.post(summary.querySummaryThirdPage, data, config);
};
// 获取纪要数量接口 暂时使用
export const getSummaryCount = async (data, config = {}) => {
  return await instance.get(summary.querySummaryCount, data, config);
};
// 纪要页面-热门纪要
export const queryHotSummaryPage = async (data, config = {}) => {
  return await instance.post(summary.queryHotSummaryPage, data, config);
};
//纪要页面-会员纪要
export const queryVIPSummaryPage = async (data, config = {}) => {
  return await instance.post(summary.queryVIPSummaryPage, data, config);
};
// 纪要详情页面-收藏/取消收藏
export const summaryCollection = async (data, config = {}) => {
  return await instance.post(summary.summaryCollection, data, config);
};
// 纪要详情页面-批量取消收藏
export const summaryCollectionCancel = async (data, config = {}) => {
  return await instance.post(summary.summaryCollectionCancel, data, config);
};
// 历史记录-纪要
export const summaryHistoryList = async (data, config = {}) => {
  return await instance.post(summary.summaryHistoryList, data, config);
};
// 历史记录-纪要-仅查询最近3个月
export const summaryHistoryListLimit = async (data, config = {}) => {
  return await instance.post(summary.summaryHistoryListLimit, data, {
    ...config,
    transformResponse: bigNumberTransformResponse
  });
};
// 纪要数量
export const summaryCountStatistics = async (data, config = {}) => {
  return await instance.post(summary.summaryCountStatistics, data, config);
};
// 发现-纪要
export const attentionSummaryList = async (data, config = {}) => {
  return await instance.post(`${COMEINURL}/brm/json/summary/analyst-summary-List`, data, config);
};
// 纪要详情-权限接口
export const checkUserBenefit = async (data, config = {}) => {
  return await instance.post(summary.checkUserBenefit, data, config);
};
// 会议数据
export const getSummaryConferenceInfo = async (data, config = {}) => {
  return await instance.post(summary.getSummaryConferenceInfo, data, config);
};
// 获取纪要音频播放地址
export const getSummaryPlayUrl = async (data, config = {}) => {
  return await instance.post(summary.getSummaryPlayUrl, data, config);
};
// 要点总结
export const querySummaryPoints = async (data, config = {}) => {
  return await instance.post(summary.querySummaryPoints, data, config);
};
// 溯源的接口
export const querySummaryPointsTrace = async (data, config = {}) => {
  return await instance.post(summary.querySummaryPointsTrace, data, config);
};
// 纪要要点脑图
export const querySummaryPointsMarkMap = async (data, config = {}) => {
  return await instance.post(summary.querySummaryPointsMarkMap, data, config);
};
// 小会要点脑图
export const queryPointsMarkMap = async (data, config = {}) => {
  return await instance.post(summary.queryPointsMarkMap, data, config);
};
// 要点数说
export const querySummaryDataSpeak = async (data, config = {}) => {
  return await instance.post(summary.querySummaryDataSpeak, data, config);
};
export const querySummaryDataSpeakTrace = async (data, config = {}) => {
  return await instance.post(summary.querySummaryDataSpeakTrace, data, config);
};
// 获取行业，上市公司，主讲人，券商机构接口
export const selectSummaryBySourceId = async (data, config = {}) => {
  return await instance.post(summary.selectSummaryBySourceId, data, config);
};
//AI纪要的鉴权鉴权接口
export const selectAISummaryByNoteId = async (data, config = {}) => {
  return await instance.post(summary.selectAiSummaryByNoteId, data, config);
};
// 自选-个股-纪要
export const queryAttentionSummaryList = async (data, config = {}) => {
  return await instance.post(summary.queryAttentionSummaryList, data, config);
};
// 问答模板
export const commonAiQuestion = async (data, config = {}) => {
  return await instance.post(summary.commonAiQuestion, data, config);
};
// 历史问答
export const listAiQa = async (data, config = {}) => {
  return await instance.post(summary.listAiQa, data, config);
};
// 发送消息
export const aiQa = async (data, config = {}) => {
  return await instance.post(summary.aiQa, data, config);
};
// 导出指标数据
export const exportAIIndicatorList = async (data) => {
  return await instance.post(summary.exportAIIndicatorList, data, {
    responseType: 'blob'
  });
};
// 埋点纪要详情29-36-0
// 埋点纪要详情-AI纪要29-36-62
// 埋点纪要详情-会议原文29-36-1
export const buryTheDetails = async (data, config = defaultConfig) => {
  return await instance.post(summary.buryTheDetails, data, config);
};
// 历史记录-纪要-清除
export const historyListCancel = async (data, config = {}) => {
  return await instance.get(summary.historyListCancel, data, config);
};
// 历史记录-纪要-清除(针对个人中心)
export const historyListCancelPersonal = async (data, config = {}) => {
  return await instance.get(summary.historyListCancelPersonal, data, config);
};
// 播放记录上报
export const playRecord = async (data) => {
  return instance.post(summary.playRecord, data);
};

// 回放开始上报
export const statisticRoadshow = async (data, config = {}) => {
  return instance.post(summary.statisticRoadshow, data, config);
};

// 获取播放记录
export const getPlayRecord = async (data) => {
  return instance.post(summary.getPlayRecordNew, data);
};

// 路演相关文档
export const noticepagedocument = async (data) => {
  return instance.post(summary.noticepagedocument, data);
};

// 路演播放文档
export const attachmentlist = async (data, config = {}) => {
  return instance.post(summary.attachmentlist, data, config);
};

// 文档摘要
export const docSummary = async (data) => {
  return instance.post(summary.docSummary, data);
};

// 文档图片
export const pptImages = async (data) => {
  return instance.post(summary.pptImages, data);
};
// 文档权限
export const summaryDocAuth = async (data, config) => {
  return instance.post(summary.summaryDocAuth, data, config);
};

// 会议-录制文件详情-按钮显示
export const getViewSummaryBtn = (data, config) => {
  return instance.post(summary.jsonMeetingSummaryNoteHasNote, data, config);
};

// 获取路演文档向量库信息
export const getRoadshowDocVectorInfo = async (data, config = {}) => {
  return await instance.post(summary.getRoadshowDocVectorInfo, data, config);
};

/**
 * 获取路演文档向量库信息-后端无权限控制
 * @param {*} data
 * @param {*} config
 * @returns
 */
export const getRoadshowDocVectorInfoWithoutAuth = async (data, config = {}) => {
  return await instance.post(summary.getRoadshowDocVectorInfoWithoutAuthApi, data, config);
};
